// Small vittyyo "yy" app icon for buttons and badges.
export const AppIcon = ({ size = 20, className = "" }) => (
  <img src="/vittyyo-icon.svg?v=3" alt="" width={size} height={size} className={`inline-block shrink-0 ${className}`} draggable={false} />
);
export default AppIcon;
